import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_DriverVerifyActivation } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "app-add-dvactivation",
	templateUrl: "./add-dvactivation.component.html",
	styleUrls: ["./add-dvactivation.component.css"],
})
export class AddDVActivationComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private DriverActivationService: DataService_DriverVerifyActivation
	) {}

	ngOnInit(): void {}

	//////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////
	TotalCount: any = 1;
	IssueDate: Date = new Date();

	Expires: any = false;
	ExpireDate: Date = new Date();

	errorMessage: any = "";

	Processing: any = false;
	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		//
		// Error handling
		//

		var fiDate = moment(this.IssueDate).format("MM/DD/YYYY");
		var feDate = this.Expires == true ? moment(this.ExpireDate).format("MM/DD/YYYY") : "";

		if (String(fiDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid issue date or expire date";

			return;
		}

		if (this.TotalCount <= 0) {
			this.errorMessage = "Must have at least 1 activation";
			return;
		}

		//
		// Call SP
		//

		this.Processing = true;

		var result = this.DriverActivationService.DriverActivationInsert(this.TotalCount, this.TotalCount, fiDate, feDate);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Activation code was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Activation Code",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////

	IssueGrowCell(val) {
		var element = <HTMLElement>val.element;
		element = element.parentElement.parentElement;
		element.style.height = "290px";
		element.style.width = "255px";
	}

	//Reset size when the date picker popup is closed
	IssueShrinkCell(val) {
		var element = <HTMLElement>val.element;
		element = element.parentElement.parentElement;
		element.style.height = "26.49px";
		element.style.width = "125.56px";
	}

	ExpireGrowCell(val) {
		var element = <HTMLElement>val.element;
		element = element.parentElement.parentElement;
		element.style.height = "290px";
		element.style.width = "255px";

		var popup = <HTMLElement>document.getElementsByClassName("ng-trigger-overlayAnimation")[0];
		popup.style.top = "27px";
	}

	//Reset size when the date picker popup is closed
	ExpireShrinkCell(val) {
		var element = <HTMLElement>val.element;
		element = element.parentElement.parentElement;
		element.style.height = "26.49px";
		element.style.width = "125.56px";
	}

	//////////////////////////////////////////////////////////////
}
